import { Authorization } from '@/types';
import { holdsForVendor } from '@/store/vendorAccess';

// Transfer access from the resolved /identity payload. A global admin is
// allowed first. Everyone else must hold the action on a unit whose id or
// partition matches the transfer bu. transfers.read is held by Manager,
// Operator, and Developer, so each of those roles enters Transfers.

function holdsAction(actions: string[] | undefined, action: string): boolean {
  return (actions ?? []).some((entry) => entry.trim() === action);
}

// Nav/route gate: a global admin, or any unit that holds transfers.read.
export function canEnterTransfers(
  authorization: Authorization | null | undefined,
): boolean {
  if (!authorization) {
    return false;
  }
  if (authorization.globalAdmin) {
    return true;
  }
  return authorization.units.some((unit) => holdsAction(unit.actions, 'transfers.read'));
}

// Whether the caller may read a transfer in a given bu.
export function canReadTransferInBu(
  authorization: Authorization | null | undefined,
  transferBu: string | null | undefined,
): boolean {
  return holdsForVendor(authorization, transferBu, 'transfers.read');
}

// Technical metadata for one transfer. transfers.read_technical is held by
// Developer on that transfer's business unit. A global admin is allowed for every unit.
export function canReadTechnicalInBu(
  authorization: Authorization | null | undefined,
  transferBu: string | null | undefined,
): boolean {
  return holdsForVendor(authorization, transferBu, 'transfers.read_technical');
}

// Manual retry. transfers.retry is held by Operator and Developer. A global admin
// is allowed for every business unit. Manager does not hold the action.
export function canRetryTransfer(
  authorization: Authorization | null | undefined,
  transferBu: string | null | undefined,
): boolean {
  return holdsForVendor(authorization, transferBu, 'transfers.retry');
}

// Ad hoc submit and Fix and resubmit. transfers.adhoc is held by Operator and
// Developer. A global admin is allowed for every business unit.
export function canSubmitAdHoc(
  authorization: Authorization | null | undefined,
  transferBu: string | null | undefined,
): boolean {
  return holdsForVendor(authorization, transferBu, 'transfers.adhoc');
}
